import styled from "styled-components"
import { className } from "./articlePreview.className"
import { Link } from "gatsby"
import Img from "../gatsbyImage/gatsbyImage"

export const Container = styled.div`
  margin-bottom: 100px;
`
export const ArticleWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
`

export const Article = styled(Link)`
  width: 24.4%;
  box-sizing: border-box;
  margin-bottom: 15px;
  text-decoration: none;
  color: black;
  :not(:nth-child(4n)) {
    margin-right: 0.8%;
  }
  :hover {
    cursor: pointer;
  }

  :hover .${className.image} {
    opacity: 0.6;
  }
  :hover .${className.titleArea} {
    transform: translateY(0);
    /* width: 76%;
    height: 76%; */

    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border-radius: 10px 10px 0 0;
    opacity: 0.9;
  }
  :hover .${className.context} {
    opacity: 1;
  }
`
export const ImageArea = styled.div`
  position: relative;
`
export const ImgWrap = styled.div`
  width: 100%;
`

export const TitleArea = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 80%;
  height: 80%;
  transform: translateY(65%);
  background-color: #f7f7f7;
  color: ${props => props.color};
  border: 3px solid ${props => props.color};
  z-index: 1;
  transition: transform 0.5s, width 0.5s, height 0.5s;
  :before {
    content: "";
    display: inline-block;
    height: 100%;
    width: 0;
    vertical-align: middle;
  }
`
export const TitleWrap = styled.div`
  width: 100%;
  display: inline-block;
  vertical-align: middle;
`
export const DateLabel = styled.p`
  font-size: 18px;
  text-align: center;
  margin-bottom: 10px;
`
export const Hr = styled.hr`
  width: 90%;
  margin-top: 10px;
  margin-bottom: 15px;
`
export const ArticleTitle = styled.h3`
  text-align: center;
  font-size: 20px;
  font-weight: bold;
`
export const ContextArea = styled.div`
  background-color: ${props => props.color};
  padding: 15px;
  box-sizing: border-box;
  border-radius: 0 0 10px 10px;
`
export const Context = styled.p`
  font-size: 18px;
  line-height: 1.5;
  opacity: 0;
  color: white;
  /* 刪節號 */
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`
